import defineMessages from "../../../../common/helpers/defineMessages";

const messages = defineMessages({
    notPlayable: {
        id: "planCard.notPlayable",
    },
});

export default messages;